module.exports = __webpack_public_path__ + "static/solutions-hero-778cb6478a9fdbc3c16412b4334873ad.jpg";